import { render, staticRenderFns } from "./HistoryButton.vue?vue&type=template&id=f1d61090&scoped=true"
import script from "./HistoryButton.vue?vue&type=script&lang=js"
export * from "./HistoryButton.vue?vue&type=script&lang=js"
import style0 from "./HistoryButton.vue?vue&type=style&index=0&id=f1d61090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d61090",
  null
  
)

export default component.exports